import { useContext } from "react";
import { useEffect, useState } from "react";
import { Stage, Layer, Shape } from 'react-konva';
import { Context } from "../../../App";
import './PlanCanvas.scss';

export default function PlanCanvas({handleEntrance, planImage}) {
    const {initialProps} = useContext(Context);
    const [hover, setHover] = useState();
    const [scaleFactor, setScaleFactor] = useState();
    const [plans, setPlans] = useState();

    useEffect(() => {
        return () => {
            document.body.style.cursor = "default";
        }
    }, []);

    useEffect(() => {
        const {offsetWidth} = document.querySelector("#plan");
        setScaleFactor(offsetWidth / 1150);
    });

    useEffect(() => {
        if (initialProps.canvasPoints) {
            const plans = initialProps.canvasPoints.map(element => {
                return {
                    ...element,
                    path: JSON.parse(element.path)
                }
            })
            setPlans(plans)
        }
    }, [initialProps]);

    return (
        <div className="plan">
            <div className="plan__text" data-text="">Выберите интересующий Вас подъезд на плане</div>
            <div className="plan__icon">
                <svg width={68} height={72} class="svg-icon icon-compass" style={{transform: `rotate(${initialProps.rotation}deg)`}}>
                    <use xlinkHref="/static/svg/sprite.svg#compass"></use>
                </svg>
            </div>
            <div id="plan">
                <Stage width={1150} height={610} >
                    <Layer className="plan__canvas">
                       { plans && plans.map((plan, key) => {
                            return <>
                                <Shape
                                    sceneFunc={(context, shape) => {
                                        const points = plan.path;
                                        context.beginPath();

                                        points.forEach(coord => {
                                            const x = coord[0] * scaleFactor;
                                            const y = coord[1] * scaleFactor;

                                            context.lineTo(x, y);
                                        });

                                        context.closePath();
                                        context.fillStrokeShape(shape);
                                    }}
                                    fill={hover === key ?  plan.fill : ""}
                                    onMouseMove={() => setHover(key)}
                                    onMouseOut={() => setHover()}
                                    stroke={"black"}
                                    onClick={() => handleEntrance(plan.entrance_id)}
                                    onTouchStart={() => handleEntrance(plan.entrance_id)}
                                />
                            </>
                        })}
                    </Layer>
                </Stage>
                <img src={initialProps.planImageLink} alt="" className="plan-image" />
            </div>
        </div>

    );
}
